var map = {
	"./Avatar-1.png": "41ef",
	"./Avatar-2.png": "caf3",
	"./Avatar-3.png": "da4c",
	"./Illustration.png": "3dba",
	"./css/main.scss": "a0d8",
	"./css/tailwind.css": "def6",
	"./dashboard-banner.png": "7ed3",
	"./employmentType.svg": "88de",
	"./filetype-pdf.png": "cbe6",
	"./filetype-xls.png": "a97a",
	"./icons/README.md": "c860",
	"./icons/cloud-upload.png": "2cbf",
	"./icons/cloud-upload.svg": "ecad",
	"./icons/pdf-file.png": "0441",
	"./icons/pdf-file.svg": "140c",
	"./icons/source/account.svg": "920a",
	"./icons/source/active-checked-icon.svg": "2af9",
	"./icons/source/active-move-icon.svg": "8748",
	"./icons/source/add-account.svg": "0463",
	"./icons/source/addition.svg": "81d3",
	"./icons/source/advance_icon.svg": "c918",
	"./icons/source/analytic.svg": "ba8f",
	"./icons/source/approvalHierachy.svg": "149d",
	"./icons/source/arrow-up.svg": "a9e5",
	"./icons/source/arrow_exchange.svg": "b558",
	"./icons/source/arrow_line.svg": "0a24",
	"./icons/source/attachment.svg": "becc",
	"./icons/source/back_arrow.svg": "4520",
	"./icons/source/bag-solid.svg": "96e3",
	"./icons/source/baggage-solid.svg": "8545",
	"./icons/source/banner.svg": "67dd",
	"./icons/source/basket.svg": "27b1",
	"./icons/source/bell.svg": "9964",
	"./icons/source/benefits.svg": "ef99",
	"./icons/source/bills.svg": "f959",
	"./icons/source/birthday.svg": "0bed",
	"./icons/source/black-download-icon.svg": "733b",
	"./icons/source/blue-building.svg": "463a",
	"./icons/source/blue-gross-icon.svg": "6f95",
	"./icons/source/building-fill.svg": "2655",
	"./icons/source/bulb-alert.svg": "2f68",
	"./icons/source/calendar-blue.svg": "e067",
	"./icons/source/calendar-broken.svg": "ea04",
	"./icons/source/calendar-dot.svg": "48f8",
	"./icons/source/calendar-green.svg": "d1c3",
	"./icons/source/calendar-solid.svg": "3fd9",
	"./icons/source/calendar.svg": "e1c0",
	"./icons/source/camera.svg": "2381",
	"./icons/source/cancel-icon.svg": "fb0f",
	"./icons/source/cancel.svg": "021b",
	"./icons/source/cancelNotification.svg": "dd84",
	"./icons/source/carbon-setting.svg": "4c95",
	"./icons/source/card_arrow.svg": "8976",
	"./icons/source/caret-down.svg": "02b2",
	"./icons/source/cash.svg": "cc2d",
	"./icons/source/chart-vector.svg": "73ba",
	"./icons/source/chart.svg": "1ae5",
	"./icons/source/chevronDown.svg": "5c2a",
	"./icons/source/chevronLeft.svg": "9925",
	"./icons/source/chevronRight.svg": "7e2d",
	"./icons/source/chevronUp.svg": "4f42",
	"./icons/source/clarity-icon.svg": "efaa",
	"./icons/source/clock-minus.svg": "4eb0",
	"./icons/source/close-icon.svg": "aa89",
	"./icons/source/close.svg": "5ae0",
	"./icons/source/closeModal.svg": "1766",
	"./icons/source/cloudenly_logo.svg": "d54c",
	"./icons/source/comment-outline.svg": "0462",
	"./icons/source/comment-plus-icon.svg": "2c3d",
	"./icons/source/comreview_illustration.svg": "87be",
	"./icons/source/copy-linear.svg": "4440",
	"./icons/source/copy.svg": "79e6",
	"./icons/source/create.svg": "1db4",
	"./icons/source/creditCard.svg": "a59e",
	"./icons/source/csv.svg": "5de5",
	"./icons/source/dashboard-error.svg": "d4ea",
	"./icons/source/dashboard.svg": "d604",
	"./icons/source/deactivate.svg": "6a68",
	"./icons/source/delete.svg": "91e1",
	"./icons/source/department.svg": "96b2",
	"./icons/source/distribution.svg": "bad0",
	"./icons/source/doc-cycle.svg": "11a6",
	"./icons/source/doc.svg": "89d0",
	"./icons/source/document.svg": "a4e4",
	"./icons/source/double-file.svg": "4de9",
	"./icons/source/doubleCash.svg": "aa95",
	"./icons/source/down-arrow.svg": "2f06",
	"./icons/source/downArrow.svg": "8f96",
	"./icons/source/download-icon.svg": "cc97",
	"./icons/source/download.svg": "86b6",
	"./icons/source/drag-icon.svg": "cd46",
	"./icons/source/edit.svg": "2bc6",
	"./icons/source/employee_payrun.svg": "0276",
	"./icons/source/employees.svg": "6f73",
	"./icons/source/empty-box.svg": "90b3",
	"./icons/source/empty-conflicts.svg": "9642",
	"./icons/source/emptyFolders.svg": "9752",
	"./icons/source/empty_agreement.svg": "22d4",
	"./icons/source/empty_comments.svg": "40bb",
	"./icons/source/empty_role.svg": "7e62",
	"./icons/source/error-403.svg": "3639",
	"./icons/source/error-404.svg": "1d52",
	"./icons/source/excel.svg": "66fd",
	"./icons/source/expense-icon.svg": "3e46",
	"./icons/source/expense-union.svg": "2906",
	"./icons/source/eye-close.svg": "968f",
	"./icons/source/eye-open.svg": "7b79",
	"./icons/source/file-checked-purple.svg": "d547",
	"./icons/source/file-checked.svg": "962f",
	"./icons/source/file-dismiss.svg": "6e21",
	"./icons/source/file-document.svg": "f530",
	"./icons/source/file-icon.svg": "dd5a",
	"./icons/source/file-queue.svg": "0a66",
	"./icons/source/file-solid.svg": "6c93",
	"./icons/source/file-upload.svg": "657c",
	"./icons/source/file.svg": "eb15",
	"./icons/source/file_todo.svg": "b948",
	"./icons/source/flame-close.svg": "2ccf",
	"./icons/source/goals-empty.svg": "5b17",
	"./icons/source/gray-eye-icon.svg": "c2fa",
	"./icons/source/green-eye-icon.svg": "4f87",
	"./icons/source/green-gross-icon.svg": "511c",
	"./icons/source/gross-icon.svg": "dccc",
	"./icons/source/group.svg": "4897",
	"./icons/source/growth-icon.svg": "54b98",
	"./icons/source/hambuger.svg": "d369",
	"./icons/source/hero-icon.svg": "ccf5",
	"./icons/source/hexagon-ring.svg": "298a",
	"./icons/source/history-icon.svg": "43c0",
	"./icons/source/home-storage.svg": "b2d1",
	"./icons/source/huge-icon-file.svg": "2d69",
	"./icons/source/huge-icon-user.svg": "1380",
	"./icons/source/hugeicon-filter.svg": "c6bb",
	"./icons/source/hugeicons_assignments.svg": "0540",
	"./icons/source/humanar_logo.svg": "5d70",
	"./icons/source/icon-active.svg": "722a",
	"./icons/source/icon-add.svg": "4ecb",
	"./icons/source/icon-approval.svg": "e264",
	"./icons/source/icon-arrow-down.svg": "f338",
	"./icons/source/icon-arrow-left.svg": "965b",
	"./icons/source/icon-arrow-right.svg": "fe9d",
	"./icons/source/icon-arrows-exchange.svg": "a15d",
	"./icons/source/icon-attachment.svg": "3597",
	"./icons/source/icon-audit.svg": "ffb3",
	"./icons/source/icon-badge.svg": "debf",
	"./icons/source/icon-building.svg": "b763",
	"./icons/source/icon-calender.svg": "627a",
	"./icons/source/icon-cancel.svg": "8587",
	"./icons/source/icon-chart.svg": "f616",
	"./icons/source/icon-check-round.svg": "0330",
	"./icons/source/icon-check-square.svg": "55fe",
	"./icons/source/icon-check.svg": "7ef4",
	"./icons/source/icon-checked.svg": "282d",
	"./icons/source/icon-chevron-down.svg": "15e9",
	"./icons/source/icon-clockin.svg": "d31d",
	"./icons/source/icon-close-flame.svg": "b1e56",
	"./icons/source/icon-close.svg": "5542",
	"./icons/source/icon-comments-active.svg": "7d9a",
	"./icons/source/icon-comments.svg": "0de5",
	"./icons/source/icon-compensation.svg": "41f7",
	"./icons/source/icon-copy-white.svg": "5b0f",
	"./icons/source/icon-copy.svg": "1b04",
	"./icons/source/icon-dashed.svg": "b50b",
	"./icons/source/icon-date.svg": "fc7a",
	"./icons/source/icon-department.svg": "9a58",
	"./icons/source/icon-display-black.svg": "e4f8",
	"./icons/source/icon-display-grid.svg": "5e2e4",
	"./icons/source/icon-display.svg": "1f4b",
	"./icons/source/icon-doc.svg": "bae4",
	"./icons/source/icon-dot.svg": "8040",
	"./icons/source/icon-download.svg": "05f2",
	"./icons/source/icon-edit.svg": "5ae7",
	"./icons/source/icon-empty.svg": "36a1",
	"./icons/source/icon-expense-2.svg": "a9a2",
	"./icons/source/icon-expense.svg": "a4ef",
	"./icons/source/icon-eye.svg": "7c23",
	"./icons/source/icon-facebook.svg": "6f30",
	"./icons/source/icon-financial.svg": "063b",
	"./icons/source/icon-flag.svg": "7a53",
	"./icons/source/icon-folder.svg": "6fc9",
	"./icons/source/icon-grid.svg": "cd40",
	"./icons/source/icon-home.svg": "0a3a",
	"./icons/source/icon-info-color.svg": "b2b9",
	"./icons/source/icon-info.svg": "919b",
	"./icons/source/icon-information.svg": "4b45",
	"./icons/source/icon-instagram.svg": "646b",
	"./icons/source/icon-key.svg": "447c",
	"./icons/source/icon-linkedin.svg": "93d5",
	"./icons/source/icon-location.svg": "f817",
	"./icons/source/icon-lock-green.svg": "8978",
	"./icons/source/icon-lock.svg": "e23d",
	"./icons/source/icon-manager.svg": "7369",
	"./icons/source/icon-map.svg": "6634",
	"./icons/source/icon-math-plus.svg": "0e0c",
	"./icons/source/icon-menu-1.svg": "322e",
	"./icons/source/icon-message-flame.svg": "0c43",
	"./icons/source/icon-message-outline.svg": "7d6d",
	"./icons/source/icon-money-2.svg": "79d6",
	"./icons/source/icon-money.svg": "c299",
	"./icons/source/icon-more.svg": "948f",
	"./icons/source/icon-notification.svg": "c76b",
	"./icons/source/icon-notify.svg": "06b1",
	"./icons/source/icon-pdf.svg": "2b92",
	"./icons/source/icon-phone.svg": "500e",
	"./icons/source/icon-plus-grey.svg": "6315",
	"./icons/source/icon-plus.svg": "5e25",
	"./icons/source/icon-printer.svg": "8fc5",
	"./icons/source/icon-requests.svg": "6db2",
	"./icons/source/icon-review-timeline.svg": "2a02",
	"./icons/source/icon-sand-clock.svg": "0da8",
	"./icons/source/icon-save-purple.svg": "ca2a",
	"./icons/source/icon-save.svg": "1992",
	"./icons/source/icon-search.svg": "0167",
	"./icons/source/icon-send-comment.svg": "f5ef",
	"./icons/source/icon-send.svg": "2f3b",
	"./icons/source/icon-share.svg": "0d01",
	"./icons/source/icon-suitcase.svg": "d6dc",
	"./icons/source/icon-switch.svg": "6492",
	"./icons/source/icon-terminate.svg": "30a6",
	"./icons/source/icon-time.svg": "c2fd",
	"./icons/source/icon-timer-2.svg": "8e33",
	"./icons/source/icon-timer.svg": "bd14",
	"./icons/source/icon-trash.svg": "7229",
	"./icons/source/icon-trending-down.svg": "c9c8",
	"./icons/source/icon-trending-up-green.svg": "85df",
	"./icons/source/icon-trending-up.svg": "1496",
	"./icons/source/icon-twitter.svg": "f6f1",
	"./icons/source/icon-unavailable.svg": "f2d4",
	"./icons/source/icon-undo.svg": "2b76",
	"./icons/source/icon-union.svg": "646f",
	"./icons/source/icon-unlock.svg": "b605",
	"./icons/source/icon-up-down.svg": "2cd3",
	"./icons/source/icon-update.svg": "928e",
	"./icons/source/icon-upgrade-1.svg": "5f6d",
	"./icons/source/icon-upgrade-alt.svg": "b6b2",
	"./icons/source/icon-upgrade.svg": "550d",
	"./icons/source/icon-upload.svg": "9443",
	"./icons/source/icon-user-list.svg": "ea0d",
	"./icons/source/icon-warning.svg": "8433",
	"./icons/source/icon.chart.svg": "dfb5",
	"./icons/source/icons-send-text.svg": "8a05",
	"./icons/source/icons-send.svg": "53f1",
	"./icons/source/id_card.svg": "0ac0",
	"./icons/source/idea-icon.svg": "cdf3",
	"./icons/source/illustration.svg": "9a8d",
	"./icons/source/illustration_approval.svg": "1509",
	"./icons/source/image.svg": "4f05",
	"./icons/source/import.svg": "eb34",
	"./icons/source/info.svg": "ac2c",
	"./icons/source/info_icon_green.svg": "6dc6",
	"./icons/source/information-line.svg": "3fa1",
	"./icons/source/jpg.svg": "8b71",
	"./icons/source/key.svg": "1841",
	"./icons/source/keys_transfer.svg": "c7a1",
	"./icons/source/levels.svg": "2071",
	"./icons/source/line-manager.svg": "f1fc",
	"./icons/source/location-empty.svg": "955d",
	"./icons/source/locationAndTax.svg": "0eae",
	"./icons/source/lock-icon.svg": "52df",
	"./icons/source/lock.svg": "b904",
	"./icons/source/logoff.svg": "77fd",
	"./icons/source/mail_forward.svg": "8b1e",
	"./icons/source/manage_sub.svg": "6b1a",
	"./icons/source/map-pin.svg": "f651",
	"./icons/source/map.svg": "629f",
	"./icons/source/math_minus.svg": "fbb7",
	"./icons/source/math_plus.svg": "0d86",
	"./icons/source/maximize.svg": "32ec",
	"./icons/source/message.svg": "5978",
	"./icons/source/meter.svg": "5ed5",
	"./icons/source/money_bag.svg": "ffb6",
	"./icons/source/more_icon.svg": "edda",
	"./icons/source/new-job.svg": "271c",
	"./icons/source/newspaper.svg": "f42e",
	"./icons/source/nextArrow.svg": "d18d",
	"./icons/source/no-leave.svg": "adb9",
	"./icons/source/non-active-move-icon.svg": "6c68",
	"./icons/source/notepad.svg": "30ec",
	"./icons/source/open_in_new.svg": "aaea",
	"./icons/source/optima_logo.svg": "b18f",
	"./icons/source/organisation.svg": "66c4",
	"./icons/source/organization_illustration.svg": "c66b",
	"./icons/source/overtime_icon.svg": "5b38",
	"./icons/source/overview-disabled.svg": "f5ce",
	"./icons/source/overview-icon.svg": "e3f6",
	"./icons/source/overview-notification-symbol.svg": "371d",
	"./icons/source/padlock.svg": "5ea0",
	"./icons/source/paste.svg": "3809",
	"./icons/source/pay-folders-sec.svg": "e139",
	"./icons/source/pay-folders.svg": "f579",
	"./icons/source/payScheduleEmptyImg.svg": "86d2",
	"./icons/source/paygrade_Illustration.svg": "9d5a",
	"./icons/source/payinsight_Illustration.svg": "92af",
	"./icons/source/payment.svg": "2ef6",
	"./icons/source/payroll.svg": "d046",
	"./icons/source/payrun.svg": "9d47",
	"./icons/source/payrunSheet.svg": "4751",
	"./icons/source/pdf.svg": "de7e",
	"./icons/source/people-union.svg": "203f",
	"./icons/source/people.svg": "9d9c",
	"./icons/source/performance.svg": "188c",
	"./icons/source/pin.svg": "c81f",
	"./icons/source/png.svg": "16b9",
	"./icons/source/powerpoint.svg": "e2a2",
	"./icons/source/ppt.svg": "5d36",
	"./icons/source/prevArrow.svg": "f56f",
	"./icons/source/print-icon.svg": "a360",
	"./icons/source/print.svg": "546f",
	"./icons/source/proof.svg": "cc39",
	"./icons/source/quota.svg": "3179",
	"./icons/source/reactivate.svg": "fe47",
	"./icons/source/red-cancel-icon.svg": "4668",
	"./icons/source/red-close-icon.svg": "2494",
	"./icons/source/red-edit.svg": "e146",
	"./icons/source/red-growth-icon.svg": "6b54",
	"./icons/source/red-padlock.svg": "7888",
	"./icons/source/red-upload-icon.svg": "9530",
	"./icons/source/red-warning-icon.svg": "0431",
	"./icons/source/refund-line.svg": "de7d",
	"./icons/source/regroup-icon.svg": "7d9e",
	"./icons/source/rename.icon.svg": "98ca",
	"./icons/source/reorder-icon.svg": "f975",
	"./icons/source/restore-icon.svg": "48c4",
	"./icons/source/review_Illustration.svg": "5c05",
	"./icons/source/reviewicon.svg": "6192",
	"./icons/source/right-arrow.svg": "ba53",
	"./icons/source/sand_clock.svg": "1bf0",
	"./icons/source/save.svg": "1d24",
	"./icons/source/search.svg": "19ff",
	"./icons/source/send-icon-send.svg": "d4ad",
	"./icons/source/settings.svg": "b402",
	"./icons/source/settingsCalendar.svg": "20dc",
	"./icons/source/shield-approved.svg": "894b",
	"./icons/source/shield-dissapproved.svg": "c7fc",
	"./icons/source/shield-open.svg": "8d4a",
	"./icons/source/shield.svg": "5292",
	"./icons/source/show_more.svg": "7c7c",
	"./icons/source/signFile.svg": "7cfd",
	"./icons/source/signIn.svg": "beb8",
	"./icons/source/smile.svg": "8076",
	"./icons/source/solar-user-icon.svg": "4a92",
	"./icons/source/solar-user-linear.svg": "c35b",
	"./icons/source/sort_size.svg": "4a01",
	"./icons/source/star-review.svg": "d31a",
	"./icons/source/status-cancelled.svg": "ef73",
	"./icons/source/storage.svg": "c79d",
	"./icons/source/subscription.svg": "a661",
	"./icons/source/success-filled.svg": "63a2",
	"./icons/source/sun-cloud.svg": "4112",
	"./icons/source/sync.svg": "70ea",
	"./icons/source/tax-empty.svg": "14d99",
	"./icons/source/template-union.svg": "970a",
	"./icons/source/toggle_side_bar.svg": "ec89",
	"./icons/source/toolbox.svg": "0b4f",
	"./icons/source/tooltip.svg": "4152",
	"./icons/source/trash-icon.svg": "7f07",
	"./icons/source/txt.svg": "fdcf",
	"./icons/source/undo.svg": "8fa6",
	"./icons/source/undraw_map.svg": "c72b",
	"./icons/source/union-icon.svg": "111c",
	"./icons/source/union.svg": "2091",
	"./icons/source/unlock.svg": "3128",
	"./icons/source/up-arrow.svg": "e363",
	"./icons/source/upgrade.svg": "b788",
	"./icons/source/upload-icon-red.svg": "6151",
	"./icons/source/upload-icon.svg": "729b",
	"./icons/source/user-bold-rounded.svg": "39d0",
	"./icons/source/user-orange.svg": "b5c1",
	"./icons/source/user-purple.svg": "21eb",
	"./icons/source/user-red.svg": "051f",
	"./icons/source/user-status.svg": "1db9",
	"./icons/source/user-union.svg": "37b8",
	"./icons/source/user.svg": "62d1",
	"./icons/source/users.svg": "3db8",
	"./icons/source/wallet-money.svg": "ae1e",
	"./icons/source/wallet.svg": "10b3",
	"./icons/source/warning.svg": "1609",
	"./icons/source/xlsx.svg": "510e",
	"./icons/source/yellow-gross-icon.svg": "523e",
	"./icons/sprite.svg": "4e81",
	"./images/Deductions-Illustration.png": "7f9c",
	"./images/Draw.png": "d5eb",
	"./images/Earnings-Illustration.png": "8848",
	"./images/Map.png": "83b95",
	"./images/Savings.png": "a28a",
	"./images/Wallet-empty.png": "8a8e",
	"./images/analytics.png": "3440",
	"./images/audit.svg": "3ace",
	"./images/basket.svg": "93dc",
	"./images/cash-bag.svg": "d164",
	"./images/cloudenly-logo.png": "fb54",
	"./images/doc-invalid.svg": "6357",
	"./images/doc-validation.svg": "b3b5",
	"./images/down-arrow.svg": "a9bb",
	"./images/download-box.png": "d9fc",
	"./images/emptyFolders.svg": "f603",
	"./images/empty_template.png": "0924",
	"./images/file-upload.png": "27fb",
	"./images/files-multi.png": "faf5",
	"./images/folder_open.png": "19ad",
	"./images/home-storage.png": "7b3c",
	"./images/huge-filter.png": "5345",
	"./images/hugeicons_assignments-gray.svg": "33d0",
	"./images/hugeicons_assignments.svg": "0a7b",
	"./images/info.svg": "db39",
	"./images/magnifying-glass.png": "6eb0",
	"./images/mail.png": "e9ce",
	"./images/office.png": "4b1f",
	"./images/revert-icon.svg": "f00b",
	"./images/rocket_sign.png": "9707",
	"./images/schedule-school-date-time.png": "18c2",
	"./images/user-status.png": "8416",
	"./jobType.svg": "167e",
	"./location.svg": "a1fb",
	"./logo.png": "cf05",
	"./male-user.png": "77a1",
	"./organizationalUnit.svg": "b25a",
	"./signature.png": "d6f5",
	"./summary_avatar.png": "58fe",
	"./unknown.png": "c02d",
	"./woman.png": "2982"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";